import { AuthActions } from "../LoginRedux/Action";
import { packageTrackerActions } from "./Action";

const initialState = {
  packageTrackerData: null,
  packageTrackerError: null,
  pdfLink: null,
  pdfError: null,
  CPSuccess: null,
  CPError: null,
  zohoPackageSuccess: null,
  zohoPackageError: null,
  updatePackageSuccess: null,
  updatePackageError: null,
  handDeliveredSuccess: null,
  handDeliveredError: null,
  createOrderCPSuccess: null,
  createOrderCPError: null,
  ZohoError: null,
  zohoSuccess: null,
  CSVDetails: null,
  CSVError: null,
  SRSuccess: null,
  SRError: null,
};

export const packageTrackerReducer = (state = initialState, action) => {
  switch (action.type) {
    case packageTrackerActions.GENERATE_CSV_SUCCESS:
      return {
        ...state,
        CSVDetails: action.payload,
        CSVError: null,
      };

    case packageTrackerActions.GENERATE_CSV_ERROR:
      return {
        ...state,
        CSVDetails: null,
        CSVError: action.payload,
      };

    case packageTrackerActions.FETCH_ZOHO_SUCCESS:
      return {
        ...state,
        zohoSuccess: action.payload,
        ZohoError: null,
      };

    case packageTrackerActions.FETCH_ZOHO_ERROR:
      return {
        ...state,
        zohoSuccess: null,
        ZohoError: action.payload,
      };

    case packageTrackerActions.CREATE_ORDER_CP_SUCCESS:
      return {
        ...state,
        createOrderCPSuccess: action.payload,
        createOrderCPError: null,
      };

    case packageTrackerActions.CREATE_ORDER_CP_ERROR:
      return {
        ...state,
        createOrderCPError: action.payload,
        createOrderCPSuccess: null,
      };

    case packageTrackerActions.MARK_HAND_DELIVER_SUCCESS:
      return {
        ...state,
        handDeliveredSuccess: action.payload,
        handDeliveredError: null,
      };

    case packageTrackerActions.MARK_HAND_DELIVER_ERROR:
      return {
        ...state,
        handDeliveredError: action.payload,
        handDeliveredSuccess: null,
      };

    case packageTrackerActions.UPDATE_PACKAGE_STATUS_SUCCESS:
      return {
        ...state,
        updatePackageSuccess: action.payload,
        updatePackageError: null,
      };

    case packageTrackerActions.UPDATE_PACKAGE_STATUS_ERROR:
      return {
        ...state,
        updatePackageError: action.payload,
        updatePackageSuccess: null,
      };

    case packageTrackerActions.CREATE_ZOHO_PACKAGE_SUCCESS:
      return {
        ...state,
        zohoPackageSuccess: action.payload,
        zohoPackageError: null,
      };

    case packageTrackerActions.CREATE_ZOHO_PACKAGE_ERROR:
      return {
        ...state,
        zohoPackageError: action.payload,
        zohoPackageSuccess: null,
      };

    case packageTrackerActions.CP_SUCCESS:
      return {
        ...state,
        CPSuccess: action.payload.result,
        CPError: null,
      };

    case packageTrackerActions.CP_FAILURE:
      return {
        ...state,
        CPError: action.payload,
        CPSuccess: null,
      };

    case packageTrackerActions.PACKAGE_SUCCESS:
      return {
        ...state,
        packageTrackerData: action.payload,
        packageTrackerError: null,
      };

    case packageTrackerActions.PACKAGE_ERROR:
      return {
        ...state,
        packageTrackerError: action.payload,
        packageTrackerData: null,
      };
    case packageTrackerActions.PRINT_PDF_SUCCESS:
      return {
        ...state,
        pdfLink: action.payload,
        pdfError: null,
      };

    case packageTrackerActions.PRINT_PDF_ERROR:
      return {
        ...state,
        pdfError: action.payload,
        pdfLink: null,
      };

    case packageTrackerActions.SR_SUCCESS:
      return {
        ...state,
        SRSuccess: action.payload,
        SRError: null,
      };

    case packageTrackerActions.SR_FAILURE:
      return {
        ...state,
        SRError: action.payload,
        SRSuccess: null,
      };

    case AuthActions.Logout_User:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
